import envConfig from "../config.js";

export const sanitizeFileName = (fileName = "downloaded-file") =>
  fileName.replace(/[^a-zA-Z0-9\-_.]/g, "");

export const downloadFile = async (bucketName, objectName, fileName) => {
  const { PROXY_URL } = envConfig;

  if (!bucketName || !objectName) {
    console.error("Missing bucketName or objectName for download");
    throw new Error("Bucket name and object name are required");
  }

  try {
    const encodedObjectName = encodeURIComponent(
      encodeURIComponent(objectName)
    );
    const proxyUrl = `${PROXY_URL}/${bucketName}/${encodedObjectName}`;
    const safeFileName = sanitizeFileName(fileName);

    console.info(`Downloading file: ${fileName} from ${proxyUrl}`);

    const link = document.createElement("a");
    link.href = proxyUrl;
    link.download = safeFileName;
    link.style.display = "none";

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    console.info(`Successfully downloaded: ${fileName}`);
  } catch (error) {
    console.error("Download failed:", error);
    throw error;
  }
};
